module.exports = {"widgetStyleData":{"styleConfig":{}}}